import { ApiError, SubscriptionError } from '../types';

export const isSubscriptionError = (error: any): error is SubscriptionError => {
  return error && typeof error === 'object' && error.code === 'TENANT0004';
};

export const handleApiError = (error: any, setError: (error: string | null) => void, setSubscriptionError: (error: SubscriptionError | null) => void) => {
  if (isSubscriptionError(error)) {
    setSubscriptionError(error);
    setError(null); // Clear any generic error
  } else {
    setError(error.message || 'An unexpected error occurred');
    setSubscriptionError(null); // Clear subscription error
  }
};